module.exports = __webpack_public_path__ + "img/magento-vs-woocommerce-showdown.ff295150.webp";